import { createContext, useContext, type ReactNode } from 'react';
import { assert } from '~/lib/assert';
import type { ShowFilters, ShowFiltersState } from './';

export type ShowFiltersContextType = ShowFiltersState & {
  clearFilters: () => void;
  reinitialize: (params: string) => void;
  setFilter: (
    field: {
      [K in keyof ShowFilters]: { field: K; items: ShowFilters[K]['items']; open?: boolean };
    }[keyof ShowFilters],
  ) => void;
  toggleFilter: (field: keyof ShowFilters) => void;
  togglePanel: () => void;
};

export const ShowFiltersContext = createContext<ShowFiltersContextType | undefined>(undefined);

export const useShowFilters = () => {
  const context = useContext(ShowFiltersContext);
  assert(context !== undefined, 'useShowFilters must be used with a ShowFiltersProvider');
  return context;
};

export interface ShowFiltersProviderProps extends ShowFiltersContextType {
  children: ReactNode;
}

export const ShowFiltersProvider = ({ children, ...rest }: ShowFiltersProviderProps) => (
  <ShowFiltersContext.Provider value={{ ...rest }}>{children}</ShowFiltersContext.Provider>
);
